const routes = [
  {
    path: 'inst',
    redirect: { name: 'InstList' },
    children: [
      // 기관 목록
      {
        path: 'list',
        name: 'InstList',
        meta: { menu: 'inst', keepAlive: true },
        component: () => import('@/pages/cmsMng/unitProgram/inst/InstListView.vue')
      },
      // 기관 등록
      {
        path: 'add',
        name: 'InstInsert',
        meta: { menu: 'inst', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/inst/InstInsertView.vue')
      },
      // 기관 수정
      {
        path: 'modify/:instId',
        name: 'InstUpdate',
        meta: { menu: 'inst', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/inst/InstUpdateView.vue'),
        props: true
      }
    ]
  },
  // 기관별최상위카테고리관리
  {
    path: 'instRootCateMngr',
    redirect: { name: 'InstRootCateList' },
    children: [
      {
        path: 'list',
        name: 'InstRootCateList',
        meta: { menu: 'instRootCateMngr', keepAlive: true },
        component: () => import('@/pages/cmsMng/unitProgram/instRootCateMngr/InstRootCateListView.vue')
      },
    ]
  },
  {
    path: 'pg',
    redirect: { name: 'PgList' },
    children: [
      // 온라인pg사 목록
      {
        path: 'list',
        name: 'PgList',
        meta: { menu: 'pg', keepAlive: true },
        component: () => import('@/pages/cmsMng/unitProgram/pg/PgListView.vue')
      },
      // 온라인pg사 등록
      {
        path: 'add',
        name: 'PgInsert',
        meta: { menu: 'pg', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/pg/PgInsertView.vue')
      },
      // 온라인pg사 수정
      {
        path: 'modify/:shopId/:instId',
        name: 'PgUpdate',
        meta: { menu: 'pg', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/pg/PgUpdateView.vue'),
        props: true
      }
    ]
  },
  {
    path: 'inst-mngr',
    redirect: { name: 'InstMngrList' },
    children: [
      // 기관별담당자관리 목록
      {
        path: 'list',
        name: 'InstMngrList',
        meta: { menu: 'instMngr', keepAlive: true },
        component: () => import('@/pages/cmsMng/unitProgram/instMngr/InstMngrListView.vue')
      },
      // 기관별담당자관리 등록
      {
        path: 'add',
        name: 'InstMngrInsert',
        meta: { menu: 'instMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/instMngr/InstMngrInsertView.vue')
      },
      // 기관별담당자관리 수정
      {
        path: 'modify/:instId/:mbrUnqId',
        name: 'InstMngrUpdate',
        meta: { menu: 'instMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/instMngr/InstMngrUpdateView.vue'),
        props: true
      }
    ]
  },
  {
    path: 'rdc-srvc',
    redirect: { name: 'RdcSrvcList' },
    children: [
      // 단위프로그램 > 감면서비스관리 > 감면서비스코드관리
      {
        path: 'list',
        name: 'RdcSrvcList',
        meta: { menu: 'rdc-srvc', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/rdcSrvc/RdcSrvcListView.vue')
      }
    ]
  },
  {
    path: 'reduc-hist',
    redirect: { name: 'ImdtRdcSrvcList' },
    children: [
      // 단위프로그램 > 감면서비스관리 > 즉시감면서비스이력
      {
        path: 'list',
        name: 'ImdtRdcSrvcList',
        meta: { menu: 'rdc-srvc', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/rdcSrvc/RdcSrvcHistView.vue')
      }
    ]
  },
  {
    path: 'org-mngr',
    redirect: { name: 'OrgMngrList' },
    children: [
      // 조직도관리 목록
      {
        path: 'list',
        name: 'OrgMngrList',
        meta: { menu: 'orgMngr', keepAlive: true },
        component: () => import('@/pages/cmsMng/unitProgram/orgMngr/OrgMngrListView.vue')
      },
      // 조직도관리 등록
      {
        path: 'add',
        name: 'OrgMngrInsert',
        meta: { menu: 'orgMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/orgMngr/OrgMngrInsertView.vue')
      },
      // 조직도관리 수정
      {
        path: 'modify/:deptId/:instId',
        name: 'OrgMngrUpdate',
        meta: { menu: 'orgMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/orgMngr/OrgMngrUpdateView.vue'),
        props: true
      },
      // 조직도관리 하위부서등록
      {
        path: 'sub-dept-add/:deptId/:instId',
        name: 'OrgMngrSubDeptInsert',
        meta: { menu: 'orgMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/orgMngr/OrgMngrSubDeptInsertView.vue'),
        props: true
      }
    ]
  },
  {
    path: 'mem-mngr',
    redirect: { name: 'MemMngrList' },
    children: [
      // 회원관리 목록
      {
        path: 'list',
        name: 'MemMngrList',
        meta: { menu: 'memMngr', keepAlive: true },
        component: () => import('@/pages/cmsMng/unitProgram/memMngr/MemMngrListView.vue')
      },
      
      // 회원관리 등록
      {
        path: 'add',
        name: 'MemMngrInsert',
        meta: { menu: 'memMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/memMngr/MemMngrInsertView.vue')
      },
      // 회원관리 수정
      {
        path: 'modify/:mbrUnqId',
        name: 'MemMngrUpdate',
        meta: { menu: 'memMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/unitProgram/memMngr/MemMngrUpdateView.vue'),
        props: true
      },
    ]
  },
]

export default routes
